import { render } from "./PropertiesStatusRadio.vue?vue&type=template&id=5a0b2c6d&scoped=true"
import script from "./PropertiesStatusRadio.vue?vue&type=script&lang=js"
export * from "./PropertiesStatusRadio.vue?vue&type=script&lang=js"

import "./PropertiesStatusRadio.vue?vue&type=style&index=0&id=5a0b2c6d&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0b2c6d"]])

export default __exports__